import { type SagaIterator } from "@redux-saga/core";
import { call, put, takeEvery } from "redux-saga/effects";
import getTansportKey from "../../services/user/b2buser.api";
import { userInfoActions } from "./slice";
import { PayloadAction } from '@reduxjs/toolkit';
import { TransportKeyDetails, TransportKeyPayload } from "../../types/transportkey";

// Worker Sagas
export function* onGetTransportKey(action: PayloadAction<TransportKeyPayload>): SagaIterator {
  try {
    const transportKey: TransportKeyDetails =  yield call(getTansportKey, action.payload); 
    yield put(userInfoActions.fetchAllSucceeded(transportKey));
    var key = encodeURIComponent(transportKey.transportKey)
    let uri : string = `${action.payload.uri}?key=${key}`;
    if(action.payload.isPBE)
        uri =  `${action.payload.uri}?key=${key}&path=pbe&app=FNM`;
    window.location.href = uri;
  } catch (e: unknown) {
    if (e instanceof Error) {
      yield put(userInfoActions.fetchAllFailure(e.message.toString()));
    }
  }
}

// Watcher Saga
function*userWatcherSaga(): SagaIterator {
  yield takeEvery(userInfoActions.fetchAll.type, onGetTransportKey);
}

export default userWatcherSaga;
